import { render, staticRenderFns } from "./Paypage.vue?vue&type=template&id=d31bcab2&scoped=true&"
import script from "./Paypage.vue?vue&type=script&lang=js&"
export * from "./Paypage.vue?vue&type=script&lang=js&"
import style0 from "./Paypage.vue?vue&type=style&index=0&id=d31bcab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31bcab2",
  null
  
)

export default component.exports